import { api, ApiRes } from './client'

export interface ReferralCode {
    id: string
    natural_profile_uid: string
    code: string
    created_at?: string
}

export const getReferralCodesForNaturalProfile = (naturalProfileUid): ApiRes<ReferralCode[]> =>
    api.get(`natural-profiles/${naturalProfileUid}/referral-codes`)

export const postGenerateNewReferralCode = (naturalProfileUid): ApiRes<ReferralCode> =>
    api.post(`natural-profiles/${naturalProfileUid}/referral-codes/generate`)
